var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 44,
    viewBox: "0 0 50 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 42.6667,
    transform: "translate(0 0.774902)",
    fill: "#FB4839"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8333 15.4416H27.9167L27.0833 14.6083H22.9167L22.0833 15.4416H19.1667V17.1083H30.8333M20 27.9416C20 28.3836 20.1756 28.8076 20.4881 29.1201C20.8007 29.4327 21.2246 29.6083 21.6667 29.6083H28.3333C28.7754 29.6083 29.1993 29.4327 29.5118 29.1201C29.8244 28.8076 30 28.3836 30 27.9416V17.9416H20V27.9416Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminDelete);
export default __webpack_public_path__ + "static/media/adminDelete.cc3b05d072f999bb69eb771a9136c154.svg";
export { ForwardRef as ReactComponent };